import { useState } from "react";
import FadeIn from "../components/FadeIn";
import { ME } from "../constants/portfolioData";

/**
 * ContactSection
 * Dark blue gradient card with email copy, LinkedIn, GitHub, and location.
 */
const ContactSection = () => {
  const [copied, setCopied] = useState(false);

  const copyEmail = () => {
    navigator.clipboard.writeText(ME.email);
    setCopied(true);
    setTimeout(() => setCopied(false), 2200);
  };

  const contactItems = [
    { ico: "✉️", label: "Email",    val: ME.email,           action: copyEmail },
    { ico: "💼", label: "LinkedIn", val: "Connect with me",  href: ME.linkedin },
    { ico: "⌥",  label: "GitHub",   val: "See my work",      href: ME.github },
    { ico: "📍", label: "Location", val: ME.location },
  ];

  return (
    <>
      <style>{`
        .contact-shell { background: var(--bg2); border: 1px solid var(--border); border-radius: 16px; overflow: hidden; }
        .contact-top { background: linear-gradient(135deg, #1e3a6e 0%, #1d4ed8 100%); padding: 3.5rem 3.5rem 3rem; border-bottom: 1px solid var(--border); display: grid; grid-template-columns: 1fr 1fr; gap: 4rem; align-items: center; }
        .ct-title { font-family: 'IBM Plex Sans', sans-serif; font-size: clamp(1.8rem, 3.5vw, 2.5rem); font-weight: 700; color: #ffffff; letter-spacing: -0.03em; line-height: 1.2; margin-bottom: 1rem; }
        .ct-title em { font-style: normal; color: #93c5fd; }
        .ct-sub { font-size: 0.95rem; color: #bfdbfe; line-height: 1.8; margin-bottom: 1.5rem; }
        .contact-items { display: grid; grid-template-columns: 1fr 1fr; gap: 0.9rem; }
        .ci { display: flex; align-items: center; gap: 0.85rem; padding: 1rem 1.1rem; background: #ffffff18; border: 1px solid #ffffff28; border-radius: 9px; cursor: pointer; transition: all 0.2s; text-decoration: none; }
        .ci:hover { border-color: #93c5fd; background: #ffffff28; }
        .ci-ico { width: 34px; height: 34px; background: #ffffff18; border-radius: 7px; display: flex; align-items: center; justify-content: center; font-size: 0.95rem; flex-shrink: 0; border: 1px solid #ffffff28; }
        .ci-label { font-family: 'IBM Plex Mono', monospace; font-size: 0.68rem; color: #93c5fd; text-transform: uppercase; letter-spacing: 0.08em; }
        .ci-val { font-size: 0.85rem; color: #ffffff; font-weight: 500; margin-top: 0.1rem; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
        .contact-bottom { padding: 1.75rem 3.5rem; display: flex; align-items: center; justify-content: space-between; background: var(--bg2); }
        .cb-note { font-family: 'IBM Plex Mono', monospace; font-size: 0.75rem; color: var(--muted); }
        .cb-note span { color: var(--green); }
      `}</style>

      <section id="contact">
        <div className="wrap">
          <FadeIn><div className="sec-eyebrow">Get In Touch</div></FadeIn>
          <FadeIn delay={0.1}>
            <div className="contact-shell">
              <div className="contact-top">
                <div>
                  <h2 className="ct-title">
                    Ready to solve <em>hard problems</em> together.
                  </h2>
                  <p className="ct-sub">
                    I'm actively interviewing for Senior and Staff Backend Engineer roles.
                    If you're building something technically interesting, I want to hear about it.
                    Typical response time: &lt;24 hours.
                  </p>
                  <div style={{ display: "flex", gap: "0.75rem", flexWrap: "wrap" }}>
                    <button className="btn-p" onClick={copyEmail}>
                      {copied ? "✓ Copied!" : "Copy Email"}
                    </button>
                    <a href={ME.resumeUrl} className="btn-s" target="_blank" rel="noreferrer"
                      style={{ color: "#e2e8f0", borderColor: "#ffffff30" }}>
                      Download Resume ↓
                    </a>
                  </div>
                </div>

                <div className="contact-items">
                  {contactItems.map(({ ico, label, val, href, action }) =>
                    href ? (
                      <a key={label} href={href} className="ci" target="_blank" rel="noreferrer">
                        <div className="ci-ico">{ico}</div>
                        <div>
                          <div className="ci-label">{label}</div>
                          <div className="ci-val">{val}</div>
                        </div>
                      </a>
                    ) : (
                      <div key={label} className="ci" onClick={action}>
                        <div className="ci-ico">{ico}</div>
                        <div>
                          <div className="ci-label">{label}</div>
                          <div className="ci-val">{val}</div>
                        </div>
                      </div>
                    )
                  )}
                </div>
              </div>

              <div className="contact-bottom">
                <span className="cb-note">
                  ⚡ Status: <span>Actively interviewing</span> · Available to start in 4 weeks
                </span>
                <a
                  href={ME.resumeUrl}
                  className="btn-s"
                  style={{ fontSize: "0.78rem", padding: "0.5rem 1rem" }}
                >
                  Full Resume ↗
                </a>
              </div>
            </div>
          </FadeIn>
        </div>
      </section>
    </>
  );
};

export default ContactSection;